import TextButton from 'LuxKit/Button/TextButton'
import { OfferComparisonOption } from 'hooks/Offers/useOfferComparison'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  option: OfferComparisonOption
}

function ViewOfferButton({ option }: Props) {
  const offerUrl = useOfferUrl(option.offer, {
    filters: option.selection.params?.filters,
    searchId: option.selection.params?.searchId,
    offerLinkIncludesFilters: true,
  })

  return (
    <TextButton fit="full-width" kind="primary" to={offerUrl} target="_blank">
      <FormattedMessage id="a4g52Ts26R" defaultMessage="View offer" />
    </TextButton>
  )
}

export default ViewOfferButton
